import { Injectable } from '@angular/core';


@Injectable()
export class ContatoTipoService {

  constructor() { }

  getTipoTelefoneCelular(itemId: number) {
    var test: boolean = false;
    if(itemId === 1 || itemId === 2) {
      test = true;
    }
    
    return test;
  }

  getTipoEmail(itemId: number) {
    var test: boolean = false;
    if(itemId === 3) {
      test = true;
    }

    return test;
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/contatos/contato-tipos/shared/contato.service.ts
 **/